/**
 * @Author:
 * @Description:
 * @DateTime: Created in 12:27 2019-10-27
 */
import EnumItem, { enumMixn } from "./enumItem";

let EnumOperates =  {
	Add:		new EnumItem('新增', 1),
	Update:		new EnumItem('修改', 2),
	Detail:		new EnumItem('详情', 3),
	Delete:		new EnumItem('删除', 4),
    Import:		new EnumItem('导入', 5),
    Deal:		new EnumItem('处理', 6),
    Audit:		new EnumItem('审核', 7),
    Submit:		new EnumItem('提交', 8),
    Confirm:	new EnumItem('确认', 9),
    Distribute:	new EnumItem('派发', 10),
    ...enumMixn
}

export default EnumOperates
